export default __webpack_public_path__ + "static/Bitrate_Test_11_WDRMODE_0_Indoor-00a229be0769a62777be7ddca6612449.avif";